import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { editCategoryDataApiCall } from "../../Store/slices/categorySlice";
import { TOAST_ERROR } from "../../utils/common.service";

export default function EditCategory() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const clientData = location?.state?.clientData;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    if (clientData) {
      reset({
        name: clientData?.name || "",
        description: clientData?.description || "",
      });
    }
  }, [clientData, reset]);

  const onSubmit = async (submitData) => {
    try {
      dispatch(setLoader(true));
      let requestBody = {
        id: clientData?.id,
        name: submitData.name,
        description: submitData.description,
      };

      await dispatch(editCategoryDataApiCall(requestBody));
      navigate(`/manage_category`);
      reset();
      dispatch(setLoader(false));
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Edit Category`} header={`category`} subHeader={`Edit Category`} />
          <div className="card rounded-3">
            <div className="card-body">
              <div className="d-flex justify-content-lg-start">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => navigate(-1)}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  {/* Name English Input */}
                  <div className="mb-3 col-4">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("name", {
                        required: "Name English is required",
                      })}
                      placeholder="Enter Name in English"
                    />
                    <div className="errorc">{errors.name?.message}</div>
                  </div>

                  {/* Description Input */}
                  <div className="mb-3 col-4">
                    <label className="form-label">Description</label>
                    <textarea
                      className="form-control"
                      {...register("description")}
                      placeholder="Enter description"
                    />
                    <div className="errorc">{errors.description?.message}</div>
                  </div>
                </div>

                <div className="mb-0 text-center">
                  <button className="btn btn-soft-primary w-25" type="submit">
                    <i className="ri-save-fill"></i>{" "}
                    <span className="fw-bold">Update</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
